export default "__VITE_ASSET__DicKOFZb__"